import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/var/www/webduan/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/webduan/src/components/catalog/CatalogFilterSidebar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/webduan/src/components/CategoryProductListing.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/webduan/src/components/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/webduan/src/components/Header.tsx");
